module.exports = __webpack_public_path__ + "static/media/FP-Battery-Pack_SS_001.2652d3b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/FP-Battery-Pack_SS_001.jpg
// module id = 1195
// module chunks = 0